<ion-header>
  <ion-toolbar>
    <ion-title>Sorten: {{mainItem.bezeichnung}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list style="padding-top: 0;">
    <ion-item lines="full" (mouseover)="hover(item)" style=" --inner-padding-end: 0;" *ngFor="let item of mainItem.sorten">
      <!-- SNIPPET:START:Content -->
      <img (click)="edit(item)" (mouseover)="hover(item)" slot="start" [src]="item.bildUrl" *ngIf="item.bildUrl.indexOf('View.aspx') === -1" style="object-fit: contain; max-height: 92px; width: 75px; margin-left: -14px; margin-right: 2px; margin-top: 2px;">
 <div (click)="edit(item)" (mouseover)="hover(item)" slot="start" *ngIf="item.bildUrl.indexOf('View.aspx') !== -1" style="height: 92px; width: 75px; margin-left: -14px; margin-right: 2px; margin-top: 2px;"></div>
<ion-label class="artikel" (mouseover)="hover(item)" [style.color]="lieferbar(item) ? 'unset' : 'lightgrey'" >
  <h2 style="font-weight: bold;" class="ion-text-wrap" >
    <ion-button color="{{item.pos.hinweis === '' ? 'primary' : 'danger'}}" class="ion-float-right" size="small" style="font-size: 9px;" (click)="edit(item)"><ion-icon name="pencil-outline"></ion-icon></ion-button>
    {{item.bezeichnung}}
  </h2>
  <ion-row class="header">
    <ion-col [size]="lieferbar(item) ? 4 : 3" style="overflow: hidden; padding-left: 0; padding-right: 0;">{{item.bestelleinheit}}</ion-col>
    <ion-col [size]="lieferbar(item) ? 4 : 3" style="overflow: hidden; padding-left: 0; padding-right: 0;" *ngIf="!topfAusblenden()">Topf</ion-col>
    <ion-col [size]="lieferbar(item) ? 4 : 3" style="overflow: hidden; padding-left: 0; padding-right: 0;" *ngIf="!isInfoView()">Preis €</ion-col>
    <ion-col size="3" *ngIf="!artikelRes.nochNichtLieferbareAnzeigen && !item.verfuegbar && item.verfuegbarAb.startsWith('verfügbar ab:')">verfügbar ab:</ion-col>
    <ion-col size="3" *ngIf="!artikelRes.nochNichtLieferbareAnzeigen && !item.verfuegbar && !item.verfuegbarAb.startsWith('verfügbar ab:')"></ion-col>
    <ion-col size="3" *ngIf="artikelRes.nochNichtLieferbareAnzeigen && nochNichtLieferbar(item)">verfügbar ab:</ion-col>
    <ion-col size="3" *ngIf="artikelRes.nochNichtLieferbareAnzeigen && nichtMehrLieferbar(item)">verfügbar bis:</ion-col>
  </ion-row>

  <ion-row class="details">
    <ion-col [size]="lieferbar(item) ? 4 : 3" style="overflow: hidden;">{{item.multiplikator * item.vpe}}</ion-col>
    <ion-col [size]="lieferbar(item) ? 4 : 3" style="overflow: hidden;" *ngIf="!topfAusblenden()">{{item.topfCm}}</ion-col>
    <ion-col [size]="lieferbar(item) ? 4 : 3" style="font-weight: bold;" *ngIf="!isInfoView() && item.preisAnzeigen">
        {{item.vkPreis.toFixed(2).replace('.', ',')}}
    </ion-col>
    <ion-col [size]="lieferbar(item) ? 4 : 3" style="font-weight: bold;" *ngIf="!isInfoView() && !item.preisAnzeigen"></ion-col>
    <ion-col size="3" *ngIf="!artikelRes.nochNichtLieferbareAnzeigen && !item.verfuegbar && item.verfuegbarAb.startsWith('verfügbar ab:')"  style="color: var(--ion-text-color,black);" class="ion-text-wrap">{{item.verfuegbarAb.substring(13)}}</ion-col>
    <ion-col size="3" *ngIf="artikelRes.nochNichtLieferbareAnzeigen && nochNichtLieferbar(item)" style="color: var(--ion-text-color,black);" class="ion-text-wrap">{{item.lieferbarAb | jsonDate | date:'dd.MM.'}}</ion-col>
    <ion-col size="3" *ngIf="artikelRes.nochNichtLieferbareAnzeigen && nichtMehrLieferbar(item)" style="color: var(--ion-text-color,black);" class="ion-text-wrap">{{item.lieferbarBis | jsonDate | date:'dd.MM.'}}</ion-col>
  </ion-row>
  <ion-row style="font-size: smaller; ">
    <ion-col size="12">{{item.zusatz}} {{item.sorte}} <span style="color: #3880ff;">{{item.pos.hinweis}}</span></ion-col>
  </ion-row>
</ion-label>
<div slot="end" *ngIf="lieferbar(item) && !isInfoView()" style="padding: 0; margin: 0;">
  <ion-grid style="padding: 0; margin: 0;">
    <ion-row style="padding: 0; margin: 0;">
        <ion-col style="text-align: center; padding: 0;">
        <ion-button size="small" color="secondary" (click)="item.pos.eh = item.pos.eh + 1; updateWarenkorb(item); calcWarenwert();"><ion-icon slot="icon-only" name="add-circle-sharp"></ion-icon></ion-button>                
        </ion-col>
    </ion-row>
    <ion-row style="padding: 0; margin: 0;">
        <ion-col style="text-align: center; padding: 0;">
        <input style="width: 48px; text-align: center;" [style.backgroundColor]="config.inputHintergrundFarbe" [style.border]="config.inputBorder" appSelectOnClick [class.number]="true" type="number" [(ngModel)]="item.pos.eh" min="0" [max]="item.maxEh" (ngModelChange)="updateWarenkorb(item); calcWarenwert();"/>
        </ion-col>
    </ion-row>
    <ion-row style="padding: 0; margin: 0;">
        <ion-col style="text-align: center; padding: 0;">
        <ion-button size="small" color="danger" [disabled]="item.pos.eh === 0" (click)="item.pos.eh = item.pos.eh - 1; updateWarenkorb(item); calcWarenwert();"><ion-icon slot="icon-only" name="remove-circle-sharp"></ion-icon></ion-button>
        </ion-col>
    </ion-row>
  </ion-grid>
</div>
      <!-- SNIPPET:END -->
    </ion-item>
  </ion-list>
</ion-content>

<ion-footer style="background-color: var(--ion-background-color);">
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-button (click)="schliessen()" expand="full">
          <ion-icon slot="start" name="close"></ion-icon>
          Schließen
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
